import React from "react";
import { Autocomplete } from "@material-ui/lab";
import { TextField, Divider } from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { styles } from "./styles";
import logoutIcon from "../../img/logout1.png";

const RightSideHeader = () => {
  const handleLogout = async () => {
    window.open(`/`, "_self");
    window.localStorage.clear();
  };
  
  return (
    <div style={styles.rightSubCont} id="nav_header">
      {/* <Autocomplete id='header'
        getOptionLabel={(option) => option.name}
        className='headerSelect'
        options={[]}
        style={{ width: 200 }}
        filterSelectedOptions
        getOptionSelected={(option, value) => option.name === value.name}
        disableClearable
        renderInput={(params) =>
          <TextField
            {...params}
            variant='outlined'
            margin='dense'
          />
        }
      /> */}
      {/* <Divider style={styles.divider} orientation='vertical' flexItem /> */}

      <span style={styles.span} className="mr-5">
        <AccountCircle style={styles.userIcon} />
        <b>
          {localStorage.getItem("email") == "route@watsoo.com"
            ? "Route"
            : JSON.parse(localStorage.getItem("data")) &&
              JSON.parse(localStorage.getItem("data")).name}
        </b>
      </span>

      <span
        className="cousor_pointer "
        style={styles.span}
        onClick={handleLogout}
      >
        <img className="ml-1" src={logoutIcon} alt="route" />
        <b className="ml-1">Logout</b>
      </span>
    </div>
  );
};

export default RightSideHeader;
